<script setup lang="ts">
import { SiteEnv } from '@env/types';

defineProps<{
    isHomePage?: boolean;
}>();
const siteConfigs = useSiteConfigs();
const openShamed = () =>
    window.open(
        siteConfigs.shamedHref,
        'Popup',
        'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30'
    );
</script>

<template>
    <div class="footer-logos-container">
        <a
            class="footer-logo-item"
            :href="siteConfigs.enamadHref"
            target="_blank"
            rel="nofollow"
            aria-label="enamad"
        >
            <mr-lazy-img
                alt="اینماد"
                :width="80"
                :height="80"
                src="/img/footer-logo/enamad.png"
            />
        </a>
        <span
            class="footer-logo-item"
            style="cursor: pointer"
            @click="openShamed"
        >
            <mr-lazy-img
                alt="مجوز ساماندهی"
                :width="80"
                :height="80"
                src="/img/footer-logo/samandehi.png"
            />
        </span>
        <span
            class="footer-logo-item"
            onclick="window.open('/img/tnemad_cert.jpg','_blank')"
            style="cursor: pointer"
        >
            <mr-lazy-img
                alt="مجوز گردشگری مجازی"
                :width="80"
                :height="80"
                src="/img/footer-logo/tnemad.jpg"
            />
        </span>
        <a
            v-if="isHomePage"
            class="footer-logo-item"
            href="https://www.aira.ir"
            style="cursor: pointer"
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label="aira"
        >
            <mr-lazy-img
                alt="نرخ بلیط شرکت‌های هواپیمایی"
                :width="80"
                :height="80"
                src="/img/footer-logo/aira.png"
            />
        </a>
        <span v-else class="footer-logo-item">
            <mr-lazy-img
                alt="مجوز سازمان هواپیمایی کشوری"
                :width="80"
                :height="80"
                src="/img/footer-logo/aira.png"
            />
        </span>
        <a
            v-if="isHomePage"
            class="footer-logo-item"
            href="https://www.cao.ir/home"
            style="cursor: pointer"
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label="passenger-rights"
        >
            <mr-lazy-img
                alt="حقوق مسافر"
                :width="80"
                :height="80"
                src="/img/footer-logo/CAO.png"
            />
        </a>
        <span v-else class="footer-logo-item">
            <mr-lazy-img
                alt="مجوز هواپیمایی"
                :width="80"
                :height="80"
                src="/img/footer-logo/CAO.png"
            />
        </span>
        <a
            v-if="isHomePage"
            class="footer-logo-item"
            href="https://www.cao.ir/paxrights"
            style="cursor: pointer"
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label="passenger-rights"
        >
            <mr-lazy-img
                alt="حقوق مسافر"
                :width="80"
                :height="80"
                src="/img/footer-logo/qr.png"
            />
        </a>
        <span v-else class="footer-logo-item">
            <mr-lazy-img
                alt="حقوق مسافر"
                :width="80"
                :height="80"
                src="/img/footer-logo/qr.png"
            />
        </span>
        <span class="footer-logo-item">
            <mr-lazy-img
                alt="RAI"
                :width="80"
                :height="80"
                src="/img/footer-logo/RAI.PNG"
            />
        </span>
        <span class="footer-logo-item">
            <mr-lazy-img
                alt="RMTO"
                :width="80"
                :height="80"
                src="/img/footer-logo/RMTO.png"
            />
        </span>
        <span
            v-if="siteConfigs.env === SiteEnv.Mrbilit"
            class="footer-logo-item"
        >
            <mr-lazy-img
                alt="ecunion"
                :width="80"
                :height="80"
                src="/img/footer-logo/ecunion.png"
            />
        </span>
        <span
            v-if="siteConfigs.env === SiteEnv.Mrbilit"
            class="footer-logo-item"
        >
            <mr-lazy-img
                alt="یاتا کد"
                :width="80"
                :height="80"
                src="/img/footer-logo/IATA.jpg"
            />
        </span>
        <span class="footer-logo-item">
            <mr-lazy-img
                alt="مجوز گردشگری"
                :width="80"
                :height="80"
                src="/img/footer-logo/ICHTO.png"
            />
        </span>
    </div>
</template>

<style scoped lang="scss">
.footer-logos-container {
    display: flex;
    justify-content: space-between;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    @include f-gap(18.5px);
    @include mobile-only {
        @include f-gap(12px);
    }
    @include no-scrollbar;
}

.footer-logo-item {
    width: 80px;
    height: 80px;
}

:deep(img) {
    width: 100%;
}
</style>
